import React from 'react'
import './header.css'
import CTA from "./cta"
import ME from '../../assets/victor.png'
import HeaderSocials from './HeaderSocials'


const Header = () => {
  return (
    // <div> Header </div>
    <header>
      <div className="container header__container">
        <h5> Hello I'm</h5>
        <h1>Adekola Victor</h1>
        <h5 className="text-light">Mobile and Web Developer</h5>
        <CTA />
        <HeaderSocials />
        <div className='me'>
          <img src={ME} alt="me" />
        </div>
        <a href="#contact" className='scroll__down'>&#62; &#62; &#62; </a>
      </div>
    </header>
  )
}

export default Header